<!-- End Breadcrumbs -->
<div class="container-fluid p-0 about-fasinating-diamond-main-section">
    <div class="mobile_version-backbutton">
        <a class="mobile-header" onclick="history.back()">
            <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Data Protection Policy</a>
    </div>
    <div class="secure-shopping about-fasinating-diamond">
        <div class="container">
            <div [innerHTML]="cmsContentData" class="section-contain"></div>
        </div>
    </div>
</div>

<!-- <section class="find-partner-page">
    <div class="mobile_version-backbutton">
      <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Data Protection...</a>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 mobile_border_top">
                <div class="right-side-section col-md-12">
                    <div class="right-top-bar">
                        <div class="col-md-12">
                            <div class="section-title-text text-center">
                                <h1 class="title">DATA PROTECTION POLICY</h1>
                            </div>
                        </div>
                        
                        <div class="unique_heading">
                            <h3 class="sub-title mb-1 text-center">DATA PROTECTION POLICY</h3>
                        </div>
                        <div class="prv-2">
                            <h3 class="sub-title">1. How we obtain your personal data</h3>
                            <p>We collect and process a very limited amount of your data when you visit and interact
                                with the TPL
                                website.</p>
                            <P>We may also obtain data about you:</P>
                            <ul>
                                <li>when we ask you to complete optional surveys that we use for research purposes and
                                    to provide you
                                    with a more relevant user experience; and</li>
                                <li>when you digitally interact with the TPL via our websites and other digital
                                    channels, for example
                                    our player portals and the resources that you access which may include the use of
                                    cookies (subject
                                    to our Cookie policy).</li>
                            </ul>
                        </div>

                         
                        <div class="prv-2">
                            <h3 class="sub-title">2. The types of personal data we process</h3>
                            <p>We only process a limited amount of your personal data. When you visit and navigate the
                                ITF website,
                                we may collect the following information:</p>
                            <ul>
                                <li>how you have reached our digital platform</li>
                                <li>your device identifiers including IP address</li>
                                <li>your browser type, versions and plug-ins, and your operating system</li>
                                <li>your journey through the ITF website, including which links you click on and
                                    searched you made,
                                    how long you stayed on a page, and other page interaction information</li>
                                <li>your subscription status (if any)</li>
                                <li>your preferences and digital journey</li>
                                <li>which adverts you responded to</li>
                                <li>which videos you watched, articles you read and content you liked</li>
                                <li>whether you wish to receive marketing from us and which types of marketing material
                                    you would like
                                    to receive</li>
                                <li>your correspondence</li>
                                <li>information collected in any forms that you complete</li>
                                <li>information contained in any correspondence, or communications received or sent by
                                    you.</li>
                            </ul>
                        </div>

                        
                        <div class="prv-2">
                            <h3 class="sub-title">3. How we will use your personal data and the legal basis for using that personal data</h3>
                            <p>Performance of our contract with you</p>
                            <p>Fulfil any contract of service that you enter into with us (e.g. when you purchase an ITF
                                product or
                                service or enter one of our website competitions)</p>
                            <p>We may use your personal data to:</p>
                            <ul>
                                <li>verify your identity, IP address and other information provided to us about you</li>
                                <li>set up your account and authenticate your registration when you register with us
                                </li>
                                <li>to enable us to administer any competitions or other offers/promotions which you
                                    enter into</li>
                                <li>receive and manage payments (if you purchase an ITF product or service) </li>
                                <li>if you provide a credit or debit card, we use third parties to check the validity of
                                    the sort
                                    code, account number and card details you submit in order to prevent fraud</li>
                                <li>communicate with you</li>
                            </ul>
                            <strong class="sub_strong">Enable our business and pursue our legitimate interests or those of a third
                                party other business interests</strong>  
                            <ul>
                                <li>We may use your personal data to:</li>
                                <li>monitor use of, improve and protect our websites and online services both online
                                    and offline
                                </li>
                                <li>update, consolidate and improve our business and the services that we provide to
                                    you as well as
                                    the accuracy of our records and to enable us to identify our users, members and
                                    service
                                    beneficiaries</li>
                                <li>identify other products and services you may be interested in and tell you about
                                    other products
                                    and services</li>
                                <li>obtain your feedback and respond to and rectify complaints received by you and
                                    other users,
                                    members and service beneficiaries of the ITF</li>
                                <li>develop and improve our federation and facilitate investment in, and the growth
                                    of, our business
                                </li>
                                <li>manage and mitigate the risks to you and our federation</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->